import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0
    }
});

export const useStyles = ({
    lineHeight
}: {
    lineHeight: number;
}) => {
    const styles = {
        container: {
            height: lineHeight
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
